
























import { defineComponent } from '@vue/composition-api';

import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default defineComponent({
  name: 'Mail',
  components: {
    Header,
    Footer
  },
  head: {
    link: [
      { rel: "stylesheet", type: "text/css", href: "/css/style.css" }
    ]
  }
});
